import { LaunchDarklyPayload } from '../models/feature-flag.models'

export const getLaunchDarklyFlag = <U extends keyof T, T = LaunchDarklyPayload>(flag: U) =>
  globalThis.shell.featureFlags?.getLaunchDarklyFlag<U, T>(flag)

export const getFeatureFlag = <T>(key: string, defaultValue: T): T =>
  globalThis.shell.featureFlags?.getFeatureFlagValue<T>(key, defaultValue) ?? defaultValue
